export type Stage = 'local' | 'beta' | 'prod';

export const stage: Stage = (() => {
  const raw = import.meta.env.VITE_STAGE;
  if (raw === 'beta' || raw === 'prod') {
    return raw;
  }
  return 'local';
})();

export const isBeta = stage === 'beta';
export const isProd = stage === 'prod';
export const isLocal = stage === 'local';
